// supabase/profile.js
import { supabase } from '@/supabase/supabaseClient';

const CACHE_TTL_MS = 60_000;
let _cache = { userId: null, data: null, at: 0 };

export async function getOwnProfile ({ force = false } = {}) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const now = Date.now();
  if (!force && _cache.userId === user.id && (now - _cache.at) < CACHE_TTL_MS) {
    return _cache.data;
  }

  const { data, error } = await supabase
    .from('user_profiles')
    .select('id, email, is_cab_admin, cabinet_id, cabinet:cabinet_id(admin_view_enabled)')
    .eq('id', user.id)
    .maybeSingle();

  if (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }

  // Aplatit le flag cabinet : la console cab-admin n'est ouverte que si le cabinet
  // a admin_view_enabled=true (découple « payeur rattaché » ↔ « vue administrateur »).
  const profile = data
    ? { ...data, admin_view_enabled: data.cabinet?.admin_view_enabled === true }
    : data;

  _cache = { userId: user.id, data: profile, at: now };
  return profile;
}

export function invalidateOwnProfileCache () {
  _cache = { userId: null, data: null, at: 0 };
}
